import { useEffect } from 'react';
import { usePoolShareUpdater } from "./hooks";
export var UserUpdater = function UserUpdater() {
  var updatePoolShares = usePoolShareUpdater();
  useEffect(function () {
    updatePoolShares();
  }, [updatePoolShares]);
  return null;
};